import React, { Fragment } from "react";
import JobBriefingOntario from "./JobBriefingOntario";
import LoneWorkerONR from "./loneWorker";
import SafetyWatchONR from "./safetyWatch";

const JobBriefingMerged = (props) => {
  const { ptype, towork, tsafwat } = props.data;
  return (
    <Fragment>
      <JobBriefingOntario {...props} />
      {ptype === "LONE WORKER" ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {ptype === "SAFETY WATCH" ? <SafetyWatchONR {...props} MERGED={true} /> : null}
      {/* for new reports where all options are mutually exclusive */}
      {towork === true ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {tsafwat === true ? <SafetyWatchONR {...props} MERGED={true} /> : null}
    </Fragment>
  );
};

export default JobBriefingMerged;



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/Ontario/JobBriefingMerged.jsx